import { useQueryClient } from '@tribeplatform/react-sdk/lib';
import { useMutation } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getAuthTokensKey } from '../../utils/keys/authToken.keys';
import { getNetworkKey } from '../../utils/keys/network.key';
export const useArchiveMemberSchemaField = (options) => {
    const { useMutationOptions, fields = 'default' } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    const networkKey = getNetworkKey();
    const authTokenKey = getAuthTokensKey();
    return useMutation(input => client.network.archiveMemberSchemaField(input, fields), {
        onMutate: variables => {
            queryClient.setQueryData(authTokenKey, old => {
                var _a, _b, _c;
                return ({
                    ...old,
                    network: {
                        ...old === null || old === void 0 ? void 0 : old.network,
                        memberFields: {
                            fields: (_c = (_b = (_a = old === null || old === void 0 ? void 0 : old.network) === null || _a === void 0 ? void 0 : _a.memberFields) === null || _b === void 0 ? void 0 : _b.fields) === null || _c === void 0 ? void 0 : _c.map(field => ({
                                ...field,
                                archived: (field === null || field === void 0 ? void 0 : field.key) === (variables === null || variables === void 0 ? void 0 : variables.key) ? true : field === null || field === void 0 ? void 0 : field.archived,
                            })),
                        },
                    },
                });
            });
            queryClient.setQueryData(networkKey, old => {
                var _a, _b;
                return ({
                    ...old,
                    memberFields: {
                        fields: (_b = (_a = old === null || old === void 0 ? void 0 : old.memberFields) === null || _a === void 0 ? void 0 : _a.fields) === null || _b === void 0 ? void 0 : _b.map(field => ({
                            ...field,
                            archived: (field === null || field === void 0 ? void 0 : field.key) === (variables === null || variables === void 0 ? void 0 : variables.key) ? true : field === null || field === void 0 ? void 0 : field.archived,
                        })),
                    },
                });
            });
        },
        onSettled: () => {
            queryClient.invalidateQueries(networkKey);
            queryClient.invalidateQueries(authTokenKey);
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useArchiveMemberSchemaField.js.map